<template>
  <div class="my-order-list">
    <ul
      class="m-order-list"
      v-if="list.length"
      v-infinite-scroll="loadMore"
      infinite-scroll-disabled="loading"
      infinite-scroll-distance="10"
    >
      <li
        class="m-order-item"
        v-for="(item, index) in list"
        :key="index"
        @click="
          $router.push({
            path: 'morderDetail',
            query: { order_id: item.order_id, order_no: item.order_no },
          })
        "
      >
        <div class="m-order-item-top">
          <div class="m-order-top">
            <span class="m-order-no">订单号：{{ item.order_no }}</span>
            <p class="m-order-status" v-if="!item.team_id">
              {{ item.fstatus }}
              <span>({{ item.payment_fstatus }})</span>
            </p>
            <p class="m-order-status" v-else>
              {{ item.team_fstatus }}
            </p>
          </div>
          <span class="m-order-datetimes">下单时间：{{ item.created_at }}</span>
        </div>
        <my-order-goods
          :list="item.goods_list"
          :total_amount="item.total_amount"
          :freight_amount="item.freight_amount"
        />
        <!-- <ul class="m-oder-payment-list">
          <li class="m-oder-payment-item" v-for="(oitem, oindex) in 3" :key="oindex">
            <label for>第{{ oindex + 1 }}尾款：</label>
            <span class="m-oder-payment">
              <em>￥</em>1888.00
            </span>
          </li>
        </ul>-->
        <!-- 待支付、待确认状态可以取消 -->
        <div class="m-order-opt">
          <mt-button
            class="m-order-btn"
            size="small"
            v-if="item.is_can_payment == 1"
            @click="dispatch($event, pay, index)"
            >去支付</mt-button
          >
          <mt-button
            class="m-order-btn"
            size="small"
            v-if="item.is_can_certificate_up == 1"
            @click="dispatch($event, voucher, index)"
            >上传凭证</mt-button
          >
          <mt-button
            class="m-order-btn info"
            size="small"
            v-if="
              item.status == 1 ||
              item.status == 2 ||
              item.status == 3 ||
              item.status == 14
            "
            @click="dispatch($event, cancel, index)"
            >取消</mt-button
          >
          <!-- 待发货申请退款  已完成 退款 -->
          <mt-button
            class="m-order-btn"
            size="small"
            v-if="item.is_can_set_express == 1"
            @click="dispatch($event, express, index)">
            添加快递信息
          </mt-button>
          <mt-button
            class="m-order-btn"
            size="small"
            v-if="item.is_can_refund_apply == 1"
            @click="dispatch($event, refund, index)"
            >申请退货</mt-button
          >
          <mt-button
            class="m-order-btn"
            size="small"
            v-if="item.is_can_receipt == 1"
            @click="dispatch($event, receipt, index)"
            >收货</mt-button
          >
          <mt-button
            class="m-order-btn"
            size="small"
            v-if="item.is_can_pick_info == 1"
            @click="dispatch($event, viewDeliveryOrder, index)"
            >查看提货单</mt-button
          >
          <mt-button
            class="m-order-btn"
            size="small"
            v-if="item.is_can_pick_apply == 1"
            @click="dispatch($event, takeDelivery, index)"
            >申请提货</mt-button
          >
          <mt-button
            class="m-order-btn info"
            size="small"
            v-if="item.status == 5 && item.delivery_way == 1"
            @click="dispatch($event, logisti, index)"
            >物流</mt-button
          >
          <mt-button
            class="m-order-btn info"
            size="small"
            v-if="item.is_can_car_info == 1"
            @click="dispatch($event, track, index)"
            >车辆跟踪</mt-button
          >
          <mt-button
            class="m-order-btn"
            size="small"
            v-if="item.status == 7 && item.is_can_comment == 1"
            @click="dispatch($event, comment, index)"
            >去评价</mt-button
          >
          <mt-button
            v-if="!item.team_id"
            class="m-order-btn"
            size="small"
            @click="dispatch($event, oneMore, index)"
            >再来一单</mt-button
          >
        </div>
      </li>
    </ul>
    <div class="m-order-empty" v-if="!list.length">
      <img :src="'search_empty.png' | mobileImagePath" alt />
      <span>暂无数据</span>
    </div>
    <mt-actionsheet :actions="actions" v-model="sheetVisible"></mt-actionsheet>
    <my-log-picker
      :isShow.sync="isLogShow"
      :delivery="delivery_info"
      :toAddress="to_address_info"
    ></my-log-picker>
    <my-refund-picker
      :isShow.sync="isRefundShow"
      :list="refundList"
      :order_id="current.order_id"
    />


    <div class="upBody" v-if="showExpress" style="width: 100%;position: fixed;top: 0;left: 0;background: rgba(0,0,0,0.5);">
      <div class="up-orderDetail-pay" style="background-color: #fff;width: 90%;border-radius: 3px;">
        <div class="up-orderDetail-pay-title" style="font-size: 0.3rem;padding: 0 0.3rem;height: 1rem;display: flex;align-items: center;justify-content: space-between;">
          <span></span>添加快递信息
          <img :src="'icon_close.png' | imagePath" @click="showExpress=false" class="pointer" style="width: 0.3rem;height: 0.3rem;"/>
        </div>
        <div style="display: flex;align-items: center;justify-content: center;">
         <div @click="toShowExpress($event)">
           <mt-field
            style="height: 0.6rem;border: 1px solid #eee;border-radius: 3px;width: 5rem;"
             placeholder="选择快递公司"
             v-model="express_name"
             :readonly="true"
           >
           </mt-field>
         </div>
         <!-- <label style="margin-right: 0.2rem;font-size: 0.2rem;"><em style="color:red">*</em>物流公司</label>
          <el-select
              style="width:5rem;"
              v-model="express_no"
              filterable
              remote
              reserve-keyword
              placeholder="请选择">
              <el-option
                @click.native="selectExpress(item)"
                v-for="item in expresses"
                :key="item.value"
                :label="item.express_name"
                :value="item.express_no">
              </el-option>
            </el-select> -->
        </div>
        <div style="display: flex;align-items: center;justify-content: center;margin-top: 0.2rem;">
          <div>
            <mt-field
             style="height: 0.6rem;border: 1px solid #eee;border-radius: 3px;width: 5rem;"
              placeholder="输入快递单号"
              v-model="logistics_no"
            >
            </mt-field>
          </div>
          <!-- <label style="margin-right: 0.2rem;font-size: 0.2rem;"><em style="color:red">*</em>快递单号</label> -->
          <!-- <el-input v-model="logistics_no" type="text" style="width:5rem;height: 0.8rem;" placeholder="输入快递单号"></el-input> -->
        </div>
        <div class="up-refund-btn" style="margin: 0.3rem auto;text-align: center;">
          <button class="active" @click="setRefundExpress" style="background-color: #f00;color: #fff;width: 2rem;line-height: 0.6rem;border-radius: 3px;">提交</button>
        </div>
      </div>
    </div>
    <express-picker
      :isShow.sync="showPicker"
      :expresses="expresses"
      @select="selectExpress"
    />
  </div>
</template>

<script>
import MyOrderGoods from "@/pages/mobile/components/MyOrderGoods";
import MyLogPicker from "@/pages/mobile/components/MyLogPicker";
import MyRefundPicker from "@/pages/mobile/components/MyRefundPicker";
import orderOptions from "@/mixins/orderOptions";
import ExpressPicker from "@/pages/mobile/components/ExpressPicker";
import { Toast } from "mint-ui";
export default {
  name: "MyOrderList",
  components: { MyOrderGoods, MyLogPicker, MyRefundPicker , ExpressPicker},
  mixins: [orderOptions],
  data() {
    return {
      isLogShow: false,
      delivery_info: [],
      to_address_info: [],
      showPicker:false
      // express_name: '',
      // express_no: '',
      // logistics_no: ''
    };
  },
  props: {
    list: [],
  },
  methods: {
    loadMore() {
      this.$emit("scrollEnd", {});
    },
    updateList() {
      this.$emit("reload", {});
    },
    jumpTo(ev, path) {
      ev.stopPropagation();
      this.$router.push(path);
    },
    toShowExpress(ev) {
      ev.stopPropagation();
      this.showPicker = true;
    },
    // 选择快递信息
    selectExpress(item) {
      this.express_name = item.express_name
      this.express_no = item.express_no
    },
    // 设置快递信息
    setRefundExpress() {
      if (this.express_name == '') {
         Toast({ message: "请选择快递公司" });
         return;
      }
      if (this.logistics_no == '') {
         Toast({ message: "请输入快递单号" });
         return;
      }
      this.$.http.post('order/setRefundExpress',{
        order_id:this.current.order_id,
        express_company:this.express_name ,
        express_no:this.express_no ,
        logistics_no:this.logistics_no
      }).then(res=>{
        Toast({ message: "设置成功" });
        this.$emit('reload')
        this.showExpress = false
      }).catch(res=>{
        this.showExpress = false
      })
    },
  },
};
</script>

<style>
.m-order-item {
  padding: 0.2rem;
  margin-top: 0.2rem;
  background: #fff;
}
.m-order-item-top {
  display: flex;
  flex-direction: column;
}
.m-order-top {
  display: flex;
  justify-content: space-between;
}
.m-order-no {
  font-weight: bold;
  font-size: 0.26rem;
}
.m-order-datetimes {
  margin-top: 0.1rem;
  color: #898989;
}
.m-order-btn {
  background: #fff;
  color: #f00;
  border-radius: 0.5rem;
  border: 1px solid #f00;
  font-size: 0.2rem;
  padding: 0.1rem 0.3rem;
  height: auto;
  transition: all 0.3 ease-in-out;
  flex-shrink: 0;
}
.m-order-btn:not(:first-child) {
  margin-left: 0.2rem;
}
.m-order-btn:focus {
  background: #f00;
  color: #fff;
}
.m-order-opt {
  margin-top: 0.2rem;
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.m-oder-payment-item label {
  font-weight: bold;
}
.m-order-freight {
  color: #898989;
}
.m-oder-payment {
  color: #f00;
  font-weight: bold;
}
.m-order-btn.info {
  background: #fff;
  color: #333;
  border: 1px solid #333;
}
.m-order-btn.info:focus {
  background: #333;
  color: #fff;
}
.m-order-empty {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  background: #fff;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}

.m-order-empty span {
  margin: 0.4rem 0;
}

.m-order-empty img {
  width: 3rem;
}

.m-order-status span {
  color: #999;
}
.m-order-status {
  color: #0168b8;
}
</style>



// WEBPACK FOOTER //
// src/pages/mobile/components/MyOrderList/index.vue